import { NgModule } from '@angular/core';
import { iBisCommonModule } from '@dohu/ibis-common';
import { BrowserModule } from '@angular/platform-browser';
import { iBisAuthModule, iBisEditUserService } from '@dohu/ibis-auth';
import { RoutesComponent } from './routes.component';
import { UploadExcelComponent } from './upload-excel/upload-excel.component';
import { DxButtonModule, DxDataGridModule, DxValidationGroupModule } from 'devextreme-angular';
import { UploadExcelService } from './upload-excel/upload-excel.service';

@NgModule({
    declarations: [
        RoutesComponent,
        UploadExcelComponent
    ],
    imports: [
        BrowserModule,
        iBisAuthModule,
        DxDataGridModule,
        DxButtonModule,
        DxValidationGroupModule,
        iBisCommonModule,
    ],
    exports: [
        RoutesComponent,
        UploadExcelComponent
    ],
    providers: [
        iBisEditUserService,
        UploadExcelService
    ]
})
export class RoutesModule { }
